import Image from 'next/image';
import styled from 'styled-components';
import { Attribution, AttributionLink, Box, CTALink, Heading, Paragraph } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { maxWidths, typography } from '@99designs/emu/settings';

const StyledParagraph = styled(Paragraph)`
    ${mediaQuery.minimum('normal')} {
        font-size: ${typography.typeScale.size4};
    }
`;

export const DirectWorkSection = () => {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginLeft="auto"
            marginRight="auto"
            flexDirection={['column-reverse', 'column-reverse', 'row', 'row']}
            paddingY={['3bu', '3bu', '4bu', '6bu']}
            paddingX={['1bu', '2bu', '2bu', '2bu']}
            maxWidth={`${maxWidths.content.widescreen}px`}
        >
            <Box display="flex" flexDirection="column">
                <Box
                    position="relative"
                    height={['250px', '300px', '400px', '485px']}
                    width={['300px', '350px', '500px', '600px']}
                    display="block"
                >
                    <Image
                        src="/images/product-landing/hero/logo-design/contest-focus/Logo_designer_image.png"
                        alt={__placeholder('by coric design')}
                        objectFit="cover"
                        layout="fill"
                    />
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="end"
                    paddingRight={['3bu', '3bu', '4bu', '6bu']}
                >
                    <Attribution>
                        <AttributionLink href="https://99designs.com/profiles/coricdesign">
                            {__placeholder('by coric design')}
                        </AttributionLink>
                    </Attribution>
                </Box>
            </Box>
            <Box paddingLeft={['none', 'none', '2bu', '3bu']}>
                <div style={{ color: '#03803E' }}>
                    <Heading accessibilityLevel={2} appearanceLevel={3}>
                        {__placeholder('Prefer to work directly with a designer?')}
                    </Heading>
                </div>
                <Box paddingTop={['1bu', '1.5bu']}>
                    <StyledParagraph>
                        {__placeholder(
                            "Browse portfolios and find a professional logo designer who'll take the time to understand your brand, then work together to bring your vision to life with a custom logo."
                        )}
                    </StyledParagraph>
                </Box>
                <Box paddingTop={['1bu', '1.5bu']}>
                    <CTALink href="/designers/search">
                        {__placeholder('See logo designers')}
                    </CTALink>
                </Box>
            </Box>
        </Box>
    );
};
